class Google {

    constructor(id_cliente){
      
        var scope = document.createElement('meta');
        scope.name = "google-signin-scope";
        scope.content = "profile email";
       
        var client_id = document.createElement('meta');
        client_id.name = "google-signin-client_id";
        client_id.content = id_cliente;

        var api = document.createElement('script');
        api.src = "https://apis.google.com/js/platform.js";
        api.async = true;
        api.defer = true;

        document.getElementsByTagName('head')[0].appendChild(scope);
        document.getElementsByTagName('head')[0].appendChild(client_id);
        document.getElementsByTagName('head')[0].appendChild(api);
    }


    signOut() {
        var auth2 = gapi.auth2.getAuthInstance();
        auth2.signOut().then(function () {
            console.log('User signed out.');
        });
    }
}